export const MINUTE_IN_MILLISECONDS = 60000;
// localStorage keys
export const KEY_ROUTE = 'KEY_ROUTE';
export const KEY_DESTINATION = 'KEY_DESTINATION';
export const KEY_STOP = 'KEY_STOP';
export const KEY_TRAIN_LINE = 'KEY_TRAIN_LINE';

// types of routes
export const ROUTE_CTA_BUS = 'ROUTE_CTA_BUS';
export const ROUTE_CTA_TRAIN = 'ROUTE_CTA_BUS';

export const CTA_L_TRAINS = [
    {
        type: 'route',
        routeId: 'red',
        routeName: 'Red Line',
        routeColor: 'red'
    }, {
        type: 'route',
        routeId: 'blue',
        routeName: 'Blue Line',
        routeColor: 'blue',
    }, {
        type: 'route',
        routeId: 'brn',
        routeName: 'Brown Line',
        routeColor: 'brown'
    }, {
        type: 'route',
        routeId: 'g',
        routeName: 'Green Line',
        routeColor: 'green'
    }, {
        type: 'route',
        routeId: 'o',
        routeName: 'Orange Line',
        routeColor: 'orange'
    }, {
        type: 'route',
        routeId: 'pexp',
        routeName: 'Purple Line',
        routeColor: 'purple'
    }, {
        type: 'route',
        routeId: 'pnk',
        routeName: 'Pink Line',
        routeColor: 'pink'
    }, {
        type: 'route',
        routeId: 'y',
        routeName: 'Yellow Line',
        routeColor: '#FFEB3B'
    }
];

export const ctaMapToCityOfChicagoTrainId = [
    { ctaId: 'Red', routeId: 'red'},
    { ctaId: 'Blue', routeId: 'blue' },
    { ctaId: 'Brn', routeId: 'brn' }, 
    { ctaId: 'G', routeId: 'g' },
    { ctaId: 'Org', routeId: 'o' },
    { ctaId: 'P', routeId: 'pexp' },
    { ctaId: 'Pink', routeId: 'pnk' },
    { ctaId: 'Y', routeId: 'y' }
];

export const CtaTrainLineIds = [
    'Red', 'Blue', 'Brn', 'G', 'Org', 'P', 'Pink', 'Y'
];

